import React, {useCallback, useEffect} from "react";
import {connect} from "react-redux";
import {
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    useMediaQuery,
    useTheme,
    Box,
    Button, Alert
} from "@mui/material";
import {useForm} from "react-hook-form";
import {workspaceActions} from "../../store/actions/workspaceAction";
import {SettingsDialog as Dialog, SettingsDialogDescription, SettingsFormSection} from "../settings/SettingsDialog";
import TrackingDomainMultiSelect from "../tracking-domain/TrackingDomainMultiSelect";
import {alertActions} from "../../store/actions/alertActions";

export function AddWorkspace(props) {

    const {create, error} = props;
    const {alert} = props.state;

    const {register, handleSubmit, control, formState: {errors}} = useForm();

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const handleOnSubmit = (data) => {
        let trackingDomainIds = "";
        data?.trackingDomain?.forEach((ws) => {
            if (trackingDomainIds !== "") {
                trackingDomainIds += "," + ws?.value
            } else {
                trackingDomainIds += ws?.value
            }
        });

        if (trackingDomainIds?.length === 0) {
            error("Choose at least 1 tracking domain.");
            return false;
        }

        let result = {
            name: data?.name,
            trackingDomainIds: trackingDomainIds
        };
        create(result);
    };

    const handleClose = useCallback((event, reason) => {
        if (reason === 'backdropClick') {
            return false;
        }
        props.history.push({pathname: "/settings/team/workspaces", state: {from: props.location}});
    }, [props]);

    useEffect(() => {
        if (alert?.successMsg !== "") {
            props.history.push({pathname: "/settings/team/workspaces", state: {from: props.location}});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [alert?.successMsg])

    return <Dialog open onClose={handleClose} fullWidth fullScreen={fullScreen} maxWidth="sm" aria-labelledby="create-workspace-form">
        <DialogTitle id="create-workspace-form">Create a new workspace
            <SettingsDialogDescription>Organize your campaigns and give your team a dedicated workspace.</SettingsDialogDescription>
        </DialogTitle>
        <DialogContent>
            {alert.errorMsg && <Alert severity="error" variant="filled" sx={{mb: 2}}>{alert.errorMsg}</Alert>}
            <Box component="form" onSubmit={handleSubmit(handleOnSubmit)} autoComplete="off">
                <TextField error={!!errors.name} helperText={errors.name ? 'Enter a workspace name (up to 100 characters).' : undefined}
                    variant="outlined" margin="dense" size="small" id="workspace-name" name="name" type="text"
                    {...register("name", {required: true, maxLength: 100})} placeholder="Enter workspace name"
                    fullWidth label="Workspace name" slotProps={{inputLabel: {shrink: true}}}/>
                <SettingsFormSection title="Tracking domains" description="Choose at least one domain to use for tracking in this workspace.">
                    <TrackingDomainMultiSelect errors={errors} control={control} inputLabel="Tracking domains" inputName="trackingDomain"/>
                </SettingsFormSection>
            </Box>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleClose} color="inherit">Cancel</Button>
            <Button onClick={handleSubmit(handleOnSubmit)} variant="contained">Create workspace</Button>
        </DialogActions>
    </Dialog>;
}

const mapStateToProps = (state) => {
    return {
        state: {
            workspace: state.workspace,
            alert: state.alert
        }
    }
};

const mapDispatchToProps = {
    create: workspaceActions.create,
    error: alertActions.error,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddWorkspace);